import { useEffect, useState } from "react";
import {
    collection,
    getDocs,
} from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import Swal from "sweetalert2";

import { db, functions } from "../../firebase";

export default function AdminPushNotification({
    clubId,
    themeColor,
}) {

    const [players, setPlayers] = useState([]);
    const [selectedPlayers, setSelectedPlayers] = useState([]);
    const [search, setSearch] = useState("");
    const [title, setTitle] = useState("");
    const [body, setBody] = useState("");

    const [sending, setSending] = useState(false);

    useEffect(() => {
        loadPlayers();
    }, []);

    const loadPlayers = async () => {

        try {

            const snap = await getDocs(
                collection(db, "users")
            );

            const filtered = snap.docs
                .map(doc => ({
                    uid: doc.id,
                    ...doc.data(),
                }))
                .filter(user =>
                    user.playedClubs?.includes(clubId)
                );

            setPlayers(filtered);

        } catch (err) {
            console.error(err);
        }
    };

    const filteredPlayers = players.filter((player) => {

        const name =
            player.displayName?.toLowerCase() || "";

        const username =
            player.username?.toLowerCase() || "";

        const searchValue =
            search.toLowerCase();

        return (
            name.includes(searchValue) ||
            username.includes(searchValue)
        );
    });

    const sendNotification = async () => {

        if (!title || !body) {

            Swal.fire(
                "Missing Fields",
                "Please enter title and message",
                "warning"
            );

            return;
        }

        if (!selectedPlayers.length) {

            Swal.fire(
                "No Players Selected",
                "Please select at least one player",
                "warning"
            );

            return;
        }

        try {

            setSending(true);

            const sendSelectedPlayersNotification =
                httpsCallable(
                    functions,
                    "sendSelectedPlayersNotification"
                );

            await sendSelectedPlayersNotification({
                uids: selectedPlayers,
                title,
                body,
            });

            Swal.fire({
                icon: "success",
                title: "Notification Sent",
                text: "Push notification sent successfully.",
                confirmButtonColor: themeColor,
            });

            setTitle("");
            setBody("");
            setSelectedPlayers([]);

        } catch (err) {

            console.error(err);

            Swal.fire({
                icon: "error",
                title: "Send Failed",
                text: err.message,
            });

        } finally {
            setSending(false);
        }
    };

    return (
        <div
            className="card border-0 shadow-sm rounded-4 p-4"
            style={{
                background: `linear-gradient(135deg, var(--card-bg), ${themeColor}08)`,
                border: `1px solid ${themeColor}10`,
            }}
        >

            {/* TITLE */}
            <div className="mb-3">

                <label className="form-label fw-semibold">
                    Notification Title
                </label>

                <input
                    type="text"
                    className="form-control rounded-3"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    placeholder="Enter title"
                />
            </div>

            {/* MESSAGE */}
            <div className="mb-3">

                <label className="form-label fw-semibold">
                    Message
                </label>

                <textarea
                    className="form-control rounded-3"
                    rows={4}
                    value={body}
                    onChange={(e) => setBody(e.target.value)}
                    placeholder="Enter message"
                />
            </div>

            {/* PLAYER LIST */}
            <div className="mb-4">

                <label className="form-label fw-semibold">
                    Select Players
                </label>
                <div className="mb-3">

                    <input
                        type="text"
                        className="form-control rounded-3"
                        placeholder="Search players..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </div>
                <div className="small text-muted mb-2">
                    {selectedPlayers.length} selected
                </div>
                <div
                    className="border rounded-4 p-3"
                    style={{
                        maxHeight: 300,
                        overflowY: "auto",
                        background: "var(--bs-body-bg)",
                    }}
                >

                    {filteredPlayers.map((player) => {

                        const checked =
                            selectedPlayers.includes(player.uid);

                        return (
                            <div
                                key={player.uid}
                                className="form-check mb-2"
                            >

                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    checked={checked}
                                    onChange={(e) => {

                                        if (e.target.checked) {

                                            setSelectedPlayers(prev => [
                                                ...prev,
                                                player.uid,
                                            ]);

                                        } else {

                                            setSelectedPlayers(prev =>
                                                prev.filter(
                                                    id => id !== player.uid
                                                )
                                            );
                                        }
                                    }}
                                />

                                <label className="form-check-label">
                                    {player.displayName || "Unnamed Player"}
                                </label>
                            </div>
                        );
                    })}
                </div>
            </div>

            {/* SEND BUTTON */}
            <button
                className="btn text-white fw-bold rounded-pill px-4"
                style={{
                    backgroundColor: themeColor,
                }}
                disabled={sending}
                onClick={sendNotification}
            >

                {sending ? (
                    <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Sending...
                    </>
                ) : (
                    <>
                        <i className="bi bi-send-fill me-2"></i>
                        Send Notification
                    </>
                )}
            </button>
        </div>
    );
}